import { ReactNode } from 'react';
import styled from 'styled-components';
import Config from 'Config';

const Wrap = styled.div`
    width: 100%;
    flex: 0 0 100%;
    min-width: 100%;
    display: flex;
    justify-content: center;
`;

const Bar = styled.div`
    width: 100%;
    background: #f5f5f5;
    padding: 22px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-align: center;
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #333;
`;

const Hint = styled.div`
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: ${Config.color.red};
`;

const ButtonsRow = styled.div`
    margin-top: 10px;
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`;

type Props = {
    dataTestId?: string;
    title?: string;
    hint?: string;
    showHint?: boolean;
    uploadAction: ReactNode;
    notApplicableAction?: ReactNode;
};

export default function PhotoRequirementEmptyCard({
    dataTestId = 'photo-card-empty',
    title = 'No photos have been uploaded',
    hint = 'At least 1 Photo Required',
    showHint = true,
    uploadAction,
    notApplicableAction,
}: Props) {
    return (
        <Wrap data-test-id={dataTestId}>
            <Bar>
                <Title>{title}</Title>
                {showHint && <Hint>{hint}</Hint>}
                <ButtonsRow>
                    {notApplicableAction}
                    {uploadAction}
                </ButtonsRow>
            </Bar>
        </Wrap>
    );
}
